export default __webpack_public_path__ + "2cbbc6cbcaffa3bc4b7f1f8f923e4218.webp";